import { Directive, HostBinding, OnInit } from '@angular/core';

import { LinkTarget } from '../../constants/link-target.enum';
import { ContextService } from '../../shared-context/context.service';

// This directive sets the default 'target' property for `<a>` tag elements based on what the
// configuration data has set.
// TODO: Remove all `<a href="javascript:void(0)">...</a>` so that we can use the `<base target="">`
// The `<base target="..">` should be preferred because it doesn't rely on JS.
// We can't use that approach yet because in IE11, the `<base target>` property ignores our workaround for
// making `<a>` function as `<button>` via `href="javascript:void(0)"`
@Directive({
    selector: 'a[ohpDefaultLinkTarget]'
})
export class DefaultLinkTargetDirective implements OnInit {
    @HostBinding('target') public target: LinkTarget;

    constructor(
        private readonly contextService: ContextService
    ) {
    }

    public ngOnInit() {
        this.target = this.contextService.sharedContext.defaultLinkTarget;
    }
}
